import React from 'react';
import { Head } from 'react-static';

export default ({ image }) => {
  const title = 'Physician Disability Insurance for Doctors | Northwestern Mutual';
  const description = 'Physician disability insurance products from Northwestern Mutual fit the unique needs of disability insurance for doctors and dentists.';
  const productName = 'Physicians and Dentists Disability Insurance';
  const url = 'https://www.northwesternmutual.com/disability-insurance/physicians-and-dentists-disability-insurance/';
  const imageAlt = 'Two women in the medical field talking.';
  const publisher = 'Northwestern Mutual';
  const imageAbsolutePath = `https://www.northwesternmutual.com${image}`;

  return (
    <Head>
      <meta name="addsearch-category" content="Planning" />
      <meta name="keywords" content="Physicians, dentists, disability insurance, physicians and dentists disability insurance, physician disability insurance, dentist disability insurance" />
      <meta name="author" content={publisher} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={publisher} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:site" content="@NM_Financial" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content="@NM_Financial" />
      <meta name="twitter:creator:id" content="@NM_Financial" />
      <meta name="twitter:image" content={imageAbsolutePath} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "${productName}",
            "description": "${description}",
            "publisher":
            {
              "@type": "FinancialService",
              "name": "${publisher}"
            },
            "url": "${url}"
          }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "FinancialProduct",
            "name": "${productName}",
            "description": "${description}"
          }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": "Staying in Practice",
            "description": "See how we helped this ophthalmologist get back to his practice after surgery. Learn more at the Northwestern Mutual website: https://www.northwesternmutual.com/",
            "thumbnailUrl": "https://i.ytimg.com/vi/q72Ci5Dehes/default.jpg",
            "uploadDate": "2019-08-08T20:08:21Z",
            "duration": "PT2M6S",
            "embedUrl": "https://www.youtube.com/embed/q72Ci5Dehes",
            "interactionCount": "538"
          }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": "Starting Fresh",
            "description": "Watch how we helped a podiatrist maintain his lifestyle after switching to a new career when he was injured. Learn more at the Northwestern Mutual website: https://www.northwesternmutual.com/",
            "thumbnailUrl": "https://i.ytimg.com/vi/9WMi2GoCuok/default.jpg",
            "uploadDate": "2019-08-08T20:03:36Z",
            "duration": "PT1M50S",
            "embedUrl": "https://www.youtube.com/embed/9WMi2GoCuok",
            "interactionCount": "566"
          }`}
      </script>
    </Head>
  );
};
